import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class MicroLevelSaturationService {

  

  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private httpClient: HttpClient) { }

  getMicroLevelSaturationData(data: any): Observable<any[]>{
    // return this.httpClient.post<any[]>(this.baseUrl + 'getOperatorSaturationData', data);
    return this.httpClient.post<any[]>(this.O3CoreApiUrl + 'MicroLevel/getOperatorSaturationData', data);
    
  }
  getOleTotalHoursWorked(data: any): Observable<any[]>{
    //return this.httpClient.post<any[]>(this.baseUrl + 'getOleTotalHoursWorked', data);
    return this.httpClient.post<any[]>(this.O3CoreApiUrl + 'MicroLevel/getOleTotalHoursWorked', data);
  }
}
